module.exports = __webpack_public_path__ + "static/media/Буренков В.И. , Сенуси М.А..33e6c78b.pdf";